import { Container, Accordion } from "react-bootstrap";
import "./coreObjectives.css";

const CoreObjectives = () => {
  return (
    <section className="core-objectives">
      <Container>
        {/* Heading */}
        <div className="text-center mb-5">
          <span className="small-title">Our Purpose</span>
          <h1 className="main-title">Our Mission</h1>
          <div className="title-line"></div>
        </div>

        {/* Accordion */}
        <Accordion defaultActiveKey="0" flush className="custom-accordion">
          {[
            {
              title: "Uniting All Hindu Organizations & Individuals",
              body: "We unite Hindus, leaders, temples, and organizations to strengthen and preserve a unified Hindu identity with collective power and solidarity.",
            },
            {
              title: "Protection of Hindu Temples & Culture",
              body: "Safeguarding temples, traditions, rituals, and cultural heritage from erosion, encroachment, and misrepresentation.",
            },
            {
              title: "Legal Advocacy & Policy Intervention",
              body: "Advocating for constitutional rights, temple autonomy, and fair policies through legal action, research, and representation.",
            },
            {
              title: "Youth Leadership & Awareness",
              body: "Empowering Hindu youth through education, leadership development, and awareness programs rooted in Dharma.",
            },
            {
              title: "Gow Raksha (Cow Protection)",
              body: "We advocate for protection and well-being of cows as they hold deep spiritual and cultural importance.",
            },
            {
              title: "Legal & Social Support for Hindus",
              body: "Providing legal aid and support to protect rights and ensure freedom of faith.",
            },
            {
              title: "Spreading Hindu Knowledge",
              body: "Promoting Bhagavad Gita, Vedas, and ancient wisdom globally.",
            },
            {
              title: "Promoting Hindu Way of Life",
              body: "Encouraging yoga, meditation, astrology, and Vedic traditions.",
            },
            {
              title: "Mega Meets & Conferences",
              body: "Organizing global Hindu events to connect and collaborate.",
            },
            {
              title: "Hindu Warrior Movement",
              body: "Training and empowering individuals to protect Dharma.",
            },
            {
              title: "Pilgrimage Tours",
              body: "Facilitating spiritual journeys across sacred places.",
            },
            {
              title: "Advocating Hindurashtra",
              body: "Working towards a Dharmic nation rooted in Sanatan values.",
            },
          ].map((item, index) => (
            <Accordion.Item eventKey={index.toString()} key={index}>
              <Accordion.Header>{item.title}</Accordion.Header>
              <Accordion.Body>{item.body}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </Container>
    </section>
  );
};

export default CoreObjectives;
